<div class="add-lot-dialog">
  <div class="flex justify-between align-center border-bottom" style="padding: 32px 45px;">
    <div class="fc_DEDEDE fz_21">Create a new lot</div>
    <img src="./assets/images/black/close.png" style="width: 15px;height:15px" (click)="handleClose()">
  </div>
  <div style="padding: 32px 45px;" class="border-bottom">
    <form [formGroup]="form">
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Lot number</mat-label>
          <input matInput formControlName="lotNumber" required>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Lot Status</mat-label>
          <mat-select matNativeControl formControlName="status" required>
            <mat-option [value]=6>Settle</mat-option>
            <mat-option [value]=5>Unconditional</mat-option>
            <mat-option [value]=4>Exchange conditional</mat-option>
            <mat-option [value]=3>Reserved</mat-option>
            <mat-option [value]=2>EOI</mat-option>
            <mat-option [value]=1>Available</mat-option>
            <mat-option [value]=0>Unavailable</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Lot price</mat-label>
          <input matInput formControlName="price" required>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Lot size</mat-label>
          <input matInput formControlName="lotSize" required>
          <span matSuffix>m²</span>
        </mat-form-field>
      </div>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Width</mat-label>
          <input matInput formControlName="width">
          <span matSuffix>m</span>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Length</mat-label>
          <input matInput formControlName="length">
          <span matSuffix>m</span>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Stage</mat-label>
        <input matInput formControlName="stage">
      </mat-form-field>
      <mat-radio-group formControlName="parkFront" style="margin-bottom: 20px">
        <div style="display: flex; margin-bottom: 20px">
          <h4 [ngClass]="{'parkFront-required': form.get('parkFront').invalid && isSubmitted}"
            style="margin-top: 20px; margin-bottom: 0">
            Park Front</h4>
          <div style="margin-left: 50px">
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </div>
        </div>

      </mat-radio-group>
      <mat-radio-group formControlName="lakeFront" style="margin-bottom: 20px">
        <div style="display: flex;  margin-bottom: 20px">
          <h4 [ngClass]="{'lakeFront-required': form.get('lakeFront').invalid && isSubmitted}"
            style="margin-top: 20px; margin-bottom: 0">
            Lake Front</h4>
          <div style="margin-left: 50px">
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </div>

        </div>
      </mat-radio-group>
      <mat-radio-group formControlName="cornerBlock" style="margin-bottom: 20px">
        <div style="display: flex; margin-bottom: 20px">
          <h4 [ngClass]="{'cornerBlock-required': form.get('cornerBlock').invalid && isSubmitted}"
            style="margin-top: 20px; margin-bottom: 0">
            Corner Block</h4>
          <div style="margin-left: 50px">
            <mat-radio-button [value]=1 style="margin-right: 40px">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]=0>
              No
            </mat-radio-button>
          </div>
        </div>
      </mat-radio-group>
    </form>
  </div>
  <div style="display: flex; justify-content: flex-end; padding: 32px 45px;">
    <button mat-button (click)="createLot()"
            [disabled]="form.invalid"
            [ngStyle]="{'background-color': form.invalid ? 'grey' : 'blue'}"
            class="create_button">Create lot</button>
  </div>
</div>
